import React, { useState, useEffect } from "react";
import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { getToken } from "../../../../helpers/Jwt";
import CurrencyInput from "../../../../helpers/CurrencyInput";
import InputOption from "../../component/InputOption/InputOption";
import { fetchData } from "../../../../helpers/ApiUtils";
import MultiTagInput from "../../component/MultiTagInput/MultiTagInput";
import Tooltip from "../../component/Tooltip/Tooltip";

const EntryAsset = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [initialValues, setInitialValues] = useState({
        code: '',
        name: '',
        description: '',
        acquisition_date: '',
        acquisition_cost: '',
        tags: '',
        depreciation_method: '',
        useful_life: '',
        residual_value: '',
        debit_account_code: '', // (AKUN PENYUSUTAN)
        credit_account_code: '',  // (AKUMULASI AKUN PENYUSUTAN)
    });

    const [isAssetDepreciation, setAssetDepreciation] = useState(false);

    const validationSchema = Yup.object().shape({
        // name: Yup.string().required('Nama Produk is wajib diisi.'),
        // unit: Yup.string().required('Satuan Produk is wajib diisi.'),
        // // category: Yup.string().required('Kategori Produk is wajib diisi.')
    });

    const [loadingOptionAsset, setLoadingOptionAsset] = useState(false);
    const [optionAsset, setOptionAsset] = useState([]);
    const [errorOptionAsset, setErrorOptionAsset] = useState([]);

    const [loadingOptionCredit, setLoadingOptionCredit] = useState(false);
    const [optionCredit, setOptionCredit] = useState([]);
    const [errorOptionCredit, setErrorOptionCredit] = useState([]);

    const [loadingOptionDebit, setLoadingOptionDebit] = useState(false);
    const [optionDebit, setOptionDebit] = useState([]);
    const [errorOptionDebit, setErrorOptionDebit] = useState([]);

    const [loadingAccumulatedOptionDepreciation, setLoadingAccumulatedOptionDepreciation] = useState(false);
    const [AccumulatedoptionDepreciation, setAccumulatedOptionDepreciation] = useState([]);
    const [errorAccumulatedoptionDepreciation, setErrorAccumulatedoptionDepreciation] = useState([]);

    const [selectedTags, setSelectedTags] = useState([]);

    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_ASSET = "api/erpppsu/asset";

    // useEffect(() => {
    //     if (id) {
    //         fetchData(`${BASE_URL}${PATH_PRODUCT}/detail?id=${id}`,).then((product) => {
    //             if (product) {

    //                 if (product?.price_buy !== null && product?.price_buy !== "") {
    //                     setShowBuyProductLayout(true);
    //                 }

    //                 // Check if price_sell is not null or empty string
    //                 if (product?.price_sell !== null && product?.price_sell !== "") {
    //                     setShowSellProductLayout(true);
    //                 }

    //                 setInitialValues({
    //                     code: product.code || '',
    //                     name: product.name || '',
    //                     unit: product.unit || '',
    //                     category: product.category || '',
    //                     price_buy: product.price_buy || '',
    //                     price_sell: product.price_sell || '',
    //                     description: product.description || '',
    //                     account_id_buy: product.account_id_buy || '',
    //                     tax_account_id_buy: product.tax_account_id_buy || '',
    //                     account_id_sell: product.account_id_sell || '',
    //                     tax_account_id_sell: product.tax_account_id_sell || '',
    //                     monitoring_stock: product.monitoring_stock || '',
    //                     account_id_monitoring_stock: product.account_id_monitoring_stock || ''
    //                 });
    //             }
    //         });
    //     }
    // }, [id]);

    useEffect(() => {
        setLoadingOptionAsset(true);
        setLoadingOptionCredit(true);
        setLoadingOptionDebit(true);
        setLoadingAccumulatedOptionDepreciation(true);

        fetchData(`${BASE_URL}${PATH_ASSET}/optionaccount`, {
            params: {
                type: 'fixed_assets'
            }
        }, setLoadingOptionAsset, setErrorOptionAsset).then((data) => {
            setOptionAsset(data);
        });

        fetchData(`${BASE_URL}${PATH_ASSET}/optionaccount`, {
        }, setLoadingOptionCredit, setErrorOptionCredit).then((data) => {
            setOptionCredit(data);
        });

        fetchData(`${BASE_URL}${PATH_ASSET}/optionaccount`, {
            params: {
                type: 'expenses'
            }
        }, setLoadingOptionDebit, setErrorOptionDebit).then((data) => {
            setOptionDebit(data);
        });

        fetchData(`${BASE_URL}${PATH_ASSET}/optionaccount`, {
            params: {
                type: 'depreciation_amortization'
            }
        }, setLoadingAccumulatedOptionDepreciation, setErrorAccumulatedoptionDepreciation).then((data) => {
            setAccumulatedOptionDepreciation(data);
        });


    }, []);

    const handleTagsChange = (tags) => {
        setSelectedTags(tags);
    };

    const onSubmit = async (values, requests) => {
        try {
            const payload = {
                id,
                ...values,
                tags: selectedTags
            };

            await axios.post(`${BASE_URL}${PATH_ASSET}`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${getToken()}`
                }
            });

            // navigate('/activity-erpppsu/product');
        } catch (error) {
            alert(error);
            console.error('Error submitting form:', error);
        } finally {
            requests.setSubmitting(false);
        }
    };

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className="mx-auto p-4">
            <h2 className="text-2xl font-bold mb-4">
                {id ? `Edit Aset` : 'Tambah Aset'}
            </h2>

            <hr />

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                    <Form onSubmit={handleSubmit}>

                        <div className="container m-auto p-4">
                            <h3 className="font-semibold">Detail Aset</h3>
                            <div className="container m-auto grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
                                <div className="mx-3">
                                    <div className="px-3 py-2">
                                        <label htmlFor="name">
                                            Nama Aset                                            
                                        </label>
                                        <Field
                                            className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                            name="name" />
                                        <ErrorMessage name="name" component="p" className='text-red-500 text-xs mt-1' />
                                    </div>

                                    <div className="px-3 py-2">
                                        <label htmlFor="code">
                                            <span className="mr-2">
                                                <Tooltip text="Nomor/Kode untuk mengidentifikasikan aset" />
                                            </span>
                                            Nomor Aset
                                        </label>
                                        <Field
                                            className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                            name="code" />
                                        <ErrorMessage name="code" component="p" className='text-red-500 text-xs mt-1' />
                                    </div>

                                    <div className="px-3 py-2">
                                        <label htmlFor="asset_account">
                                            <span className="mr-2">
                                                <Tooltip text="Akun untuk menampung saldo aset ini. Anda dapat membuat akun aset tetap baru dari menu daftar akun." />
                                            </span>
                                            Akun Aset Tetap
                                        </label>
                                        {loadingOptionAsset ? (
                                            <h1>Loading...</h1>
                                        ) : (
                                            <InputOption
                                                returnKey="code"
                                                defaultValue={values?.asset_account}
                                                label="Pilih Akun"
                                                data={optionAsset}
                                                placeholder="Cari disini"
                                                onChange={(value) => {
                                                    setFieldValue('asset_account', value)
                                                }}
                                            />
                                        )}
                                    </div>

                                    <div className="px-3 py-2">
                                        <label htmlFor="description">Deskripsi</label>
                                        <Field
                                            as={'textarea'}
                                            className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                            name="description" />
                                        <ErrorMessage name="description" component="p" className='text-red-500 text-xs mt-1' />
                                    </div>
                                </div>
                                <div className="mx-3">
                                    <div className="px-3 py-2">
                                        <label htmlFor="acquisition_date">
                                            <span className="mr-2">
                                                <Tooltip text="Tanggal Aset ini diperoleh." />
                                            </span>
                                            Tanggal Akuisisi
                                        </label>
                                        <Field
                                            type='date'
                                            className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                            name="acquisition_date" />
                                        <ErrorMessage name="acquisition_date" component="p" className='text-red-500 text-xs mt-1' />
                                    </div>

                                    <div className="px-3 py-2">
                                        <label htmlFor="acquisition_date">
                                            <span className="mr-2">
                                                <Tooltip text="Total biaya untuk memperoleh aset ini." />
                                            </span>
                                            Biaya Akuisisi
                                        </label>
                                        <CurrencyInput
                                            id="acquisition_cost"
                                            name="acquisition_cost"
                                            currency="IDR"
                                            placeholder="Masukkan Nominal"
                                            value={values.acquisition_cost}
                                            onChange={(value) => setFieldValue('acquisition_cost', value)}
                                            className="text-end my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                        />
                                        <ErrorMessage name="acquisition_cost" component="p" className='text-red-500 text-xs mt-1' />

                                    </div>

                                    <div className="px-3 py-2">
                                        {/* AKUN INI OTOMATIS MENJADI SUMBER KREDIT UNTUK JURNAL UMUM */}
                                        <label htmlFor="credit_account_code">
                                            <span className="mr-2">
                                                <Tooltip text="Akun sementara tempat menampung saldo asset sebelumnya atau akun untuk menampung saldo aset. (contoh: modal awal, pinjaman)" />
                                            </span>
                                            Akun Dikreditkan
                                        </label>
                                        {loadingOptionCredit ? (
                                            <h1>Loading...</h1>
                                        ) : (
                                            <InputOption
                                                returnKey="code"
                                                defaultValue={values?.credit_account_code}
                                                label="Pilih Akun"
                                                data={optionCredit}
                                                placeholder="Cari disini"
                                                onChange={(value) => {
                                                    setFieldValue('credit_account_code', value)
                                                }}
                                            />
                                        )}
                                    </div>

                                    <div className="px-3 py-2">
                                        <MultiTagInput name="tags" options={['Sales', 'PPSU', 'PRSU', 'KMPSUMUT', 'TIKET']} onTagsChange={handleTagsChange} />
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="container m-auto p-4">
                            <h3 className="font-semibold">Penyusutan</h3>
                            <div className="container m-auto grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
                                <div className="mx-3">
                                    <div className="px-3 py-2">
                                        <label htmlFor="depreciation_method">
                                            <span className="mr-2">
                                                <Tooltip text="Garis lurus: penyusutan secara rata sepanjang masa manfaat. Saldo menurun: penyusutan lebih besar di awal usia asset." />
                                            </span>
                                            Metode
                                        </label>
                                        <Field
                                            as="select"
                                            name="payment_terms"
                                            className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                            onChange={(e) => setFieldValue(`depreciation_method`, e.target.value)}
                                        >
                                            <option value="">Pilih Metode Penyusutan</option>
                                            <option key={0} value={"straight_line"}>
                                                Straight Line
                                            </option>
                                            <option key={1} value={"declining_balance"}>
                                                Declining Balance
                                            </option>
                                        </Field>
                                        <ErrorMessage name="depreciation_method" component="p" className='text-red-500 text-xs mt-1' />
                                    </div>

                                    <div className="px-3 py-2">
                                        <label htmlFor="useful_life">
                                            <span className="mr-2">
                                                <Tooltip text="Panjang usia aset sejak perolehan" />
                                            </span>
                                            Masa Manfaat
                                        </label>
                                        <Field
                                            className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                            name="useful_life" />
                                        <ErrorMessage name="useful_life" component="p" className='text-red-500 text-xs mt-1' />
                                    </div>
                                    <div className="px-3 py-2">
                                        <label htmlFor="residual_value">
                                            <span className="mr-2">
                                                <Tooltip text="Perhitungan jumlah penyusutan. Akan disesuaikan atau menyesuaikan Masa Manfaat" />
                                            </span>
                                            Nilai Pertahun
                                        </label>
                                        <Field
                                            className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                            name="residual_value" />
                                        <ErrorMessage name="residual_value" component="p" className='text-red-500 text-xs mt-1' />
                                    </div>
                                </div>
                                <div className="mx-3">
                                    <div className="px-3 py-2">
                                        <label htmlFor="debit_account_code">
                                            <span className="mr-2">
                                                <Tooltip text="Akun Biaya untuk merekap penyusutan perbulan" />
                                            </span>
                                            Akun Penyusutan
                                        </label>
                                        {loadingOptionDebit ? (
                                            <h1>Loading...</h1>
                                        ) : (
                                            <InputOption
                                                returnKey="code"
                                                defaultValue={values?.debit_account_code}
                                                label="Pilih Akun"
                                                data={optionDebit}
                                                placeholder="Cari disini"
                                                onChange={(value) => {
                                                    setFieldValue('debit_account_code', value)
                                                }}
                                            />
                                        )}
                                    </div>
                                    <div className="px-3 py-2">
                                        <label htmlFor="accumulated_debit_account_code">
                                            <span className="mr-2">
                                                <Tooltip text="Akun Kontra Aset untuk menampung akumulasi penyusutan" />
                                            </span>
                                            Akumulasi Akun Penyusutan
                                        </label>
                                        {loadingAccumulatedOptionDepreciation ? (
                                            <h1>Loading...</h1>
                                        ) : (
                                            <InputOption
                                                returnKey="code"
                                                defaultValue={values?.accumulated_debit_account_code}
                                                label="Pilih Akun"
                                                data={AccumulatedoptionDepreciation}
                                                placeholder="Cari disini"
                                                onChange={(value) => {
                                                    setFieldValue('accumulated_debit_account_code', value)
                                                }}
                                            />
                                        )}
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div className="m-4 text-end">
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                                    }`}
                            >
                                {isSubmitting ? 'Menyimpan...' : 'Simpan'}
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default EntryAsset;
